module.exports = __webpack_public_path__ + "img/MZ.fd53a918.png";